var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('table',{staticClass:"z-table w-full border-collapse border border-ink-200 p-8"},[_c('thead',{staticClass:"w-full"},[_vm._t("head")],2),_vm._v(" "),_c('tbody',{staticClass:"w-full"},[_vm._t("body")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }